import React from 'react'
import { FormattedMessage } from 'react-intl'
import { fade, withStyles, Menu, IconButton, MenuItem } from '@material-ui/core'
import { InvoicesListingConsumer } from '../../../context/InvoicesListingContext'
import { useStyles } from './Styles'
import MoreVertIcon from '@material-ui/icons/MoreVert'
import PictureAsPdfOutlinedIcon from '@material-ui/icons/PictureAsPdfOutlined'
import InsertDriveFileOutlinedIcon from '@material-ui/icons/InsertDriveFileOutlined'
import CodeIcon from '@material-ui/icons/Code'
import DeleteForeverOutlinedIcon from '@material-ui/icons/DeleteForeverOutlined'
import PublicIcon from '@material-ui/icons/Public'
import BlockOutlinedIcon from '@material-ui/icons/BlockOutlined'
import DescriptionOutlinedIcon from '@material-ui/icons/DescriptionOutlined'
import PrintOutlinedIcon from '@material-ui/icons/PrintOutlined'
import Configuration from '../../../Services/Api/Configuration'
import invoicesTypes from '../../../configurations/invoices-types'

const InvoicesActionsMenu = ({ selectedRow, id, msId, isSubmitted, userPermissions, hasQuota, locale, isMs = false }) => {
  const classes = useStyles()
  const [anchorEl, setAnchorEl] = React.useState(null)
  const [isMenuView, setIsMenuView] = React.useState(false)
  const isMenuOpen = Boolean(anchorEl)
  const menuId = 'header-account-menu'
  const StyledMenu = withStyles((theme) => ({
    paper: {
      borderRadius: theme.spacing(0),
      boxShadow: `0 8px 16px -4px ${fade(theme.palette.common.white, 0.16)}`,
      backgroundColor: theme.palette.common.white,
      padding: theme.spacing(0),
      textAlign: 'left',
      '& .MuiMenu-list': {
        padding: 0,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        // width: 220,
        border: `1px solid ${theme.palette.colors.border}`
      }
    }
  }))((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: locale === 'ar' ? 'left' : 'right'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: locale === 'ar' ? 'left' : 'right'
      }}
      {...props}
    />
  ))

  const handleProfileMenuOpen = (event) => {
    setIsMenuView(true)
    setAnchorEl(event.currentTarget)
  }
  const handleMenuClose = () => {
    setAnchorEl(null)
    setTimeout(() => setIsMenuView(false), 300)
  }

  const getCurrentUserActions = () => {
    let actions = []
    let hasType = invoicesTypes?.filter(item => item.key.toString().toLowerCase() === selectedRow?.typeName?.toString()?.toLowerCase())?.length
    let isFreeze = !!selectedRow?.freezeStatus?.frozen
    if (selectedRow?.status && !isMs) {
      actions = !!userPermissions?.includes(Configuration.permissions.invoice.view) ? selectedRow?.MSStatus ? [
          {
            name: 'download-pdf',
            icon: <PictureAsPdfOutlinedIcon/>,
            disabled: !hasType
          },
          {
            name: 'download-json',
            icon: <InsertDriveFileOutlinedIcon/>
          }, {
            name: 'download-xml',
            icon: <CodeIcon/>
          }
        ] : [
          {
            name: 'download-json',
            icon: <InsertDriveFileOutlinedIcon/>
          }, {
            name: 'download-xml',
            icon: <CodeIcon/>
          }
        ]
        : []
    }
    if (selectedRow?.status && isMs) {
      actions = !!userPermissions?.includes(Configuration.permissions.invoice.view) ? [
        {
          name: 'download-pdf',
          icon: <PictureAsPdfOutlinedIcon/>,
          disabled: !hasType
        }, {
          name: 'download-json',
          icon: <InsertDriveFileOutlinedIcon/>
        }, {
          name: 'download-xml',
          icon: <CodeIcon/>
        }
      ] : []
      if (!!isSubmitted) {
        switch (selectedRow?.status) {
          case 'Valid' :
            let declineReject = (!!userPermissions?.includes(Configuration.permissions.invoice.declineReject) && !!selectedRow?.rejectRequestDate && !!selectedRow?.rejectRequestDelayedDate) ? [{
              name: 'decline-reject',
              icon: <DeleteForeverOutlinedIcon/>,
              disabled: !!isFreeze,
              isFreeze: !!isFreeze
            }] : []
            let cancel = (!!userPermissions?.includes(Configuration.permissions.invoice.cancel) && !selectedRow?.cancelRequestDate && !selectedRow?.rejectRequestDate) ? [{
              name: 'cancel',
              icon: <DeleteForeverOutlinedIcon/>,
              disabled: !!isFreeze,
              isFreeze: !!isFreeze
            }] : []
            let copy = ['i', 'c', 'd', 'ei', 'ec', 'ed'].includes(selectedRow?.typeName?.toLowerCase()) ? [{
              name: 'create-copy',
              icon: <DescriptionOutlinedIcon/>
            }] : []
            let creditDebit = (['i', 'ei'].includes(selectedRow?.typeName?.toLowerCase()) && (!selectedRow?.cancelRequestDate && !selectedRow?.rejectRequestDate)) ? [{
              name: 'create-credit-note',
              icon: <DescriptionOutlinedIcon/>,
              disabled: !!isFreeze,
              isFreeze: !!isFreeze
            },
              {
                name: 'create-debit-note',
                icon: <DescriptionOutlinedIcon/>,
                disabled: !!isFreeze,
                isFreeze: !!isFreeze
              }] : []

            let quotaActions = !!hasQuota? [...copy, ...creditDebit]:[]

            actions = [
              ...declineReject,
              ...cancel,
              ...quotaActions,
              {
                name: 'print',
                icon: <PrintOutlinedIcon/>
              },
              {
                name: 'get-public-link',
                icon: <PublicIcon/>
              }, ...actions
            ]
            break
          // case 'Cancelled' :
          //   actions = [
          //     {
          //       name: 'get-public-link',
          //       icon: <PublicIcon/>
          //     }, ...actions
          //   ]
          //   break
          default:
            break
        }
      } else {
        switch (selectedRow?.status) {
          case 'Valid' :
            let declineCancel = (!!userPermissions?.includes(Configuration.permissions.invoice.declineCancel) && !!selectedRow?.cancelRequestDate && !!selectedRow?.cancelRequestDelayedDate) ? [{
              name: 'decline-cancel',
              icon: <DeleteForeverOutlinedIcon/>,
              disabled: !!isFreeze,
              isFreeze: !!isFreeze
            }] : []
            let reject = (!!userPermissions?.includes(Configuration.permissions.invoice.reject) && !selectedRow?.cancelRequestDate && !selectedRow?.rejectRequestDate) ? [{
              name: 'reject',
              icon: <BlockOutlinedIcon/>,
              disabled: !!isFreeze,
              isFreeze: !!isFreeze
            }] : []
            actions = [
              ...declineCancel,
              ...reject,
              {
                name: 'print',
                icon: <PrintOutlinedIcon/>
              },
              {
                name: 'get-public-link',
                icon: <PublicIcon/>
              }, ...actions
            ]
            break
          // case 'Cancelled' :
          //   actions = [
          //     {
          //       name: 'get-public-link',
          //       icon: <EventIcon/>
          //     }, ...actions
          //   ]
          //   break
          default:
            break
        }
      }
    }
    return actions
  }

  let userActions = getCurrentUserActions()
  return (
    <>
      <IconButton
        aria-label={<FormattedMessage id='ActionsMenu.label'/>}
        aria-controls={menuId}
        aria-haspopup="true"
        className={classes.actionMenuButton}
        onClick={handleProfileMenuOpen}
        color="inherit"
      >
        <MoreVertIcon color='primary'/>
      </IconButton>
      {!!isMenuView &&
      <InvoicesListingConsumer>
        {({ openDialog, currentDialogAction }) => (
          <StyledMenu
            id={menuId}
            anchorEl={anchorEl}
            keepMounted
            open={isMenuOpen}
            onClose={handleMenuClose}
          >
            {!!userActions && !!userActions.length && userActions?.filter(item=> !item.isFreeze)?.map((actionData, index) => (
              !(selectedRow?.status === 'Invalid' && actionData.name === 'download-pdf') &&
              <MenuItem
                disabled={actionData?.disabled || false}
                // selected={actionData.name === currentDialogAction}
                key={index}
                onClick={() => openDialog(actionData.name, selectedRow, id, handleMenuClose, msId, isMs)}
                className={classes.buttonAction + ` ${actionData.name}`}>
                {actionData.icon}
                <FormattedMessage
                  id={`InvoicesActionsMenu.button.${actionData.name}${actionData.name === 'create-copy' ? '.' + selectedRow?.typeName?.toLowerCase() : ''}`}
                  values={{
                    strong: chunks => <strong>{chunks}</strong>
                  }}/>
              </MenuItem>
            ))}
          </StyledMenu>
        )}
      </InvoicesListingConsumer>
      }
    </>
  )
}

export default InvoicesActionsMenu
